import { notify } from 'components/Common/Toast';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isMerchant } from 'utils/helpers';

const RequireMerchant = () => {
    const location = useLocation();
    if (!isMerchant()) {
        notify('You have a lower role to continue!', 'error');
        // Redirect user to home or to somewhere else when the user is not a merchant
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    return <Outlet />;
};

export default RequireMerchant;
